// General body templates used for parsing datatable column data

import moment from "moment";
import {Tooltip} from "primereact/tooltip";

/**
 * Date format template
 */
export const dateBodyTemplate = (date: string, noTime: boolean, tooltip: string | null) => {
    let momentDate = moment(date);

    if (momentDate.isValid()) {
        const id = 'column-date-wrap-' + date.replaceAll(' ', '-').replaceAll(':', '-');
        return (
            <>
                {
                    tooltip && <Tooltip target={`#${id}`}
                                        content={tooltip}
                                        position="top"/>
                }
                <div className="column-date-wrap"
                     id={id}>
                    <div>{momentDate.format('DD.MM.YYYY')}</div>
                    {!noTime && <div>{momentDate.format('HH:mm:ss')}</div>}
                </div>
            </>
        );
    }
};